import { render, staticRenderFns } from "./widgetjob.vue?vue&type=template&id=aec9da98"
import script from "./widgetjob.vue?vue&type=script&lang=js"
export * from "./widgetjob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports